/**
 * @generated SignedSource<<d93db42c439d7cbbb31ca1a955877b2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SpaceViewsPersistenceOption = "POPULARITY" | "RECENTLY_MODIFIED" | "RECENTLY_VIEWED" | "TITLE_AZ" | "TREE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useSpaceViewsOptionsPersistence_userPreferences$data = {
  readonly spaceViewsPersistence: SpaceViewsPersistenceOption;
  readonly " $fragmentType": "useSpaceViewsOptionsPersistence_userPreferences";
};
export type useSpaceViewsOptionsPersistence_userPreferences$key = {
  readonly " $data"?: useSpaceViewsOptionsPersistence_userPreferences$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSpaceViewsOptionsPersistence_userPreferences">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "spaceKey"
    }
  ],
  "kind": "Fragment",
  "name": "useSpaceViewsOptionsPersistence_userPreferences",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "spaceKey",
          "variableName": "spaceKey"
        }
      ],
      "kind": "ScalarField",
      "name": "spaceViewsPersistence"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "6e14a936c397037e855ea8ebac2ce34c";

export default node;
